import Lottie from 'react-lottie';
import loadingAnimationData from '../../animations/loading.json';

export const Loading = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <div className="fixed bg-white left-0 top-0 h-screen w-screen flex justify-center items-center z-50">
      <Lottie data-cy="loading" height={240} width={240} options={defaultOptions} />
    </div>
  );
};
